function helperStringUpperCase (str) {
  return str.toUpperCase()
}

module.exports = helperStringUpperCase



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.5.27/~/xe-utils/helperStringUpperCase.js
// module id = 443
// module chunks = 75